import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './modules/Shared/contexts/AuthContext';
import { ProtectedRoute } from './modules/Shared/components/ProtectedRoute';
import { ParentRoute } from './modules/Shared/components/ParentRoute';
import { StudentRoute } from './modules/Shared/components/StudentRoute';

// Pages
import Landing from './modules/Auth/pages/Landing';
import Login from './modules/Auth/pages/Login';
import Signup from './modules/Auth/pages/Signup';
import VerifyEmail from './modules/Auth/pages/VerifyEmail';
import HomeRedirect from './modules/Shared/components/HomeRedirect';
import ParentHome from './modules/Parent/pages/ParentHome';
import StudentHome from './modules/Student/pages/StudentHome';
import WorksheetPlayer from './modules/Worksheet/pages/WorksheetPlayer';
import Progress from './modules/Progress/pages/Progress';
import Dashboard from './modules/Progress/pages/History';
import HistoryDetail from './modules/Progress/pages/HistoryDetail';
import { BillingPage } from './modules/Billing';
import PricingPageRoute from './modules/Billing/pages/PricingPageRoute';

function App(): JSX.Element {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          {/* Public routes */}
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/verify-email" element={<VerifyEmail />} />

          {/* Protected routes - Home redirect */}
          <Route
            path="/home"
            element={
              <ProtectedRoute>
                <HomeRedirect />
              </ProtectedRoute>
            }
          />

          {/* Protected routes - Parent */}
          <Route
            path="/parent/home"
            element={
              <ParentRoute>
                <ParentHome />
              </ParentRoute>
            }
          />

          {/* Protected routes - Student */}
          <Route
            path="/student/home"
            element={
              <StudentRoute>
                <StudentHome />
              </StudentRoute>
            }
          />
          <Route
            path="/worksheet"
            element={
              <StudentRoute>
                <WorksheetPlayer />
              </StudentRoute>
            }
          />
          <Route
            path="/progress"
            element={
              <ProtectedRoute>
                <Progress />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/:attemptId"
            element={
              <ProtectedRoute>
                <HistoryDetail />
              </ProtectedRoute>
            }
          />

          {/* Parent-only routes - Billing */}
          <Route
            path="/billing"
            element={
              <ParentRoute>
                <BillingPage />
              </ParentRoute>
            }
          />
          <Route
            path="/billing/pricing"
            element={
              <ParentRoute>
                <PricingPageRoute />
              </ParentRoute>
            }
          />

          {/* Default redirect */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
